import { AbstractLocaleHandler } from './AbstractLocaleHandler';
import { ServiceLocalizationFallbackType } from '../types';
import { isNative as isNativeJWeb } from '../../JWeb';
import getValueByInsensitiveKey from '../../../utils/getValueByInsensitiveKey';
import { LocaleType } from '../types';
import { DevicePluginFacade } from '../../JWeb/facades';
export class NativeLocaleHandler extends AbstractLocaleHandler {
  private isNative: boolean = undefined;
  private locale: LocaleType = {};

  constructor(languagesFallback: ServiceLocalizationFallbackType) {
    super(languagesFallback);
  }

  public async init(): Promise<void> {
    this.isNative = await isNativeJWeb();
    if (this.isNative) {
      const [language, country] = (
        await DevicePluginFacade.getDeviceInfoCached()
      ).locale.languageTag.split('-', 2);
      this.locale = {
        language,
        country
      };
    }
  }

  public handle(isLanguage: boolean, currentList: string[]): string {
    if (!this.isNative) {
      return super.nextHandle(isLanguage, currentList);
    }

    const nativeLocale = this.locale;

    // For fallback
    const nativeFallback = getValueByInsensitiveKey(
      this._languagesFallback,
      nativeLocale.language
    );

    return super.genericHandle({
      isLanguage: isLanguage,
      locale: nativeLocale,
      currentList: currentList,
      localeFallback: nativeFallback
    });
  }
}
